import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

interface PortalProps {
  children: React.ReactNode;
  containerId?: string;
}

export const Portal = ({
  children,
  containerId = "portal-container",
}: PortalProps) => {
  const [container, setContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    let portalContainer = document.getElementById(containerId);
    if (!portalContainer) {
      portalContainer = document.createElement("div");
      portalContainer.id = containerId;
      document.body.appendChild(portalContainer);
    }
    setContainer(portalContainer);

    return () => {
      // Portal이 언마운트될 때 컨테이너를 제거하지 않음
      // 다른 모달들이 같은 컨테이너를 사용할 수 있도록 함
    };
  }, [containerId]);

  if (!container) return null;

  return createPortal(children, container);
};
